export const initialState = {
	surveyGuidMaps: {
		isSyncing: {},
		isUnsyncing: {},
		isDeleting: {},
		isDeleted: {},
		isQueuedForDelete: {},
		isSelected: {},
		errorMessages: {},
	},
	autoFixStore: {
		_map: {},
		_list: [],
		isFixing: false,
		isStopping: false,
	},		
	jobListCache: { // CISV JobList component manages state locally, this allows us to cache that local state in redux and make it available to our selectors.
		jobListTab: 'FILTER',
		fjobs: [], // this.state.fjobs // jobs list resulting from filter params (filter gui tab, initial gui tab)
		sjobs: [], // this.state.sjobs // jobs list resulting from search params (search gui tab, second gui tab)
	}
};

export default initialState;
